import * as React from 'react'
import { inject, observer } from 'mobx-react'
import Lightbox from 'react-image-lightbox'

import Carousel from 'src/components/UI/Carousel/Carousel'
import Image from 'src/components/UI/Image/Image'
import Ui from 'src/stores/ui'

import styles from './ImageSection.module.scss'

import 'react-image-lightbox/style.css'
import { getContentfulSrcSet } from 'src/utils/image'

type Props = {
  media: any
  ui?: Ui
  handleLightbox: (index: number) => void
}

const name = 'Alt text'

@inject('ui')
@observer
class ImageSection extends React.Component<Props> {
  state = {
    lightboxIndex: -1,
  }

  render() {
    const { media, ui, handleLightbox } = this.props
    const isDesktop = ui && ui.windowWidth >= 1024
    const images = media ? media.map((m: any) => m.sources.full.url) : []

    const { lightboxIndex } = this.state

    return (
      <React.Fragment>
        <div className={styles.imageSection}>
          {isDesktop ? (
            <div className={styles.desktopWrapper}>
              {media.map(
                (image: any, index: number): JSX.Element => (
                  <div
                    onClick={() => this.setState({ lightboxIndex: index })}
                    className={styles.desktopImage}
                    key={image.sources.full.url}
                  >
                    <Image
                      critical
                      sizes="50vw"
                      src={image.sources.full.url}
                      alt={name}
                    />
                  </div>
                )
              )}
            </div>
          ) : (
              <Carousel simulateTouch={true}>
                {media.map(
                  (image: any, index: number): JSX.Element => (
                    <div
                      className={styles.slideImage}
                      key={image.sources.full.url}
                    >
                      <Image critical src={image.sources.full.url} alt={name} />
                    </div>
                  )
                )}
              </Carousel>
            )}
        </div>
        {isDesktop && lightboxIndex > -1 && (
          <Lightbox
            mainSrc={images[lightboxIndex]}
            nextSrc={images[(lightboxIndex + 1) % images.length]}
            prevSrc={
              images[(lightboxIndex + images.length - 1) % images.length]
            }
            onCloseRequest={() => this.setState({ lightboxIndex: -1 })}
            onMovePrevRequest={() =>
              this.setState({
                lightboxIndex:
                  (lightboxIndex + images.length - 1) % images.length,
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                lightboxIndex: (lightboxIndex + 1) % images.length,
              })
            }
          />
        )}
      </React.Fragment>
    )
  }
}

export default ImageSection
